<nav class="hub-nav" [ngClass]="{ 'hub-nav--navy': isAdminConexia }">
  <div class="hub-nav__container">
    <!-- sidebar-menu -->
    <div class="hub-nav__sidebar-menu">
      <ul class="nav navbar-toolbar">
        <li>
          <a
            class="nav-link sidebar-toggler js-sidebar-toggler"
            href="javascript:;"
            (click)="toggleSideMenu()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <defs>
                <style>
                  .cls-1,
                  .cls-3 {
                    fill: #fff;
                  }
                  .cls-1 {
                    stroke: #707070;
                  }
                  .cls-2 {
                    clip-path: url(#clip-path);
                  }
                </style>
                <clipPath id="clip-path">
                  <path
                    id="Rectangle_531"
                    d="M0 0h20v20H0z"
                    class="cls-1"
                    data-name="Rectangle 531"
                    transform="translate(54 23)"
                  />
                </clipPath>
              </defs>
              <g
                id="Mask_Group_98"
                class="cls-2"
                data-name="Mask Group 98"
                transform="translate(-54 -23)"
              >
                <g id="ic_menu_48px" transform="translate(50.667 19.667)">
                  <path
                    id="Path_3849"
                    d="M3.333 20h20v-2.222h-20zm0-5.556h20v-2.222h-20zm0-7.778v2.223h20V6.667z"
                    class="cls-3"
                    data-name="Path 3849"
                  />
                </g>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <!--/ sidebar-menu -->

    <!-- brand-image -->
    <div class="hub-nav__brand-image">
      <img
        src="../../../assets/img/logos/LOGO - LEX_BRANCO - 46px - Backoffice Escola.png"
        alt="LEX Education"
        title="LEX Education"
      />
    </div>
    <!--/ brand-image -->

    <!-- tenant-name -->
    <div class="hub-nav__tenant-name">
      <h1>{{ (tenantService.getCurrentTenant() | async)?.name }}</h1>
    </div>
    <!--/ tenant-name -->

    <!-- menu-dropdown -->
    <div class="hub-nav__menu-dropdown">
      <!-- <a #hubNavMenuDropdownButton class="hub-nav__menu-dropdown-button" [title]="user"
        (click)="menuDropdownButtonOnClick()">
        <span class="hub-nav__menu-dropdown-label">{{ user }}</span>
        <span id="hubNavMenuCaretIcon" class="caret" [ngClass]="isDropdownVisible ? 'caret-invert' : ''"></span>
      </a>

      <a class="hub-nav-mobile__menu-dropdown-button" [title]="user" (click)="menuDropdownButtonOnClick()">
        <i class="menu-dropdown__menu-hamburger"></i>
        <i class="menu-dropdown__menu-hamburger"></i>
        <i class="menu-dropdown__menu-hamburger"></i>
      </a>

      <ul #hubNavMenuDropdownList class="hub-nav__menu-dropdown-list"
        [ngClass]="isDropdownVisible ? '' : 'hub-nav__menu-dropdown-list--hide'">
        <li class="hub-nav__menu-dropdown-item"><a (click)="logout()">Sair</a></li>
      </ul> -->
      <div class="user_image">
        <i class="material-icons">person</i>
      </div>
      <div class="user_name" [title]="user">{{ user }}</div>

      <div class="div_separator"></div>

      <div style="height: 24px">
        <a
          [href]="tutorialUrl"
          title="Tutorial"
          target="_blank"
          style="margin-right: 14px"
        >
          <i class="material-icons">info_outline</i>
        </a>
      </div>
      <div style="height: 24px; margin-right: 14px">
        <a
          [href]="urlLexUiWeb + '/privacy-policy'"
          target="_blank"
          title="Privacidade e Proteção de Dados"
        >
          <i class="material-icons">description</i>
        </a>
      </div>
      <div style="height: 24px">
        <a (click)="logout()" title="Sair">
          <i class="material-icons">exit_to_app</i>
        </a>
      </div>
    </div>
  </div>

  <!-- nav-mobile-overlay -->
  <div
    id="hubNavMobileOverlay"
    class="hub-nav-mobile__overlay"
    [ngClass]="isDropdownVisible ? 'hub-nav-mobile__overlay--show' : ''"
  ></div>
</nav>
